exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n\r\n@media(max-width:767px){\r\n:host-context(.sidebar-open) .agentiWebContent{\r\n    margin-left: 230px;\r\n  }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/assets/css/AngularAgentiWebPrivateCommon.css
// module id = ../../../../../src/assets/css/AngularAgentiWebPrivateCommon.css
// module chunks = main